export const capitalize = (string: string): string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const capitaliseString = (str: string): string => {
    const formattedStr: string = str ? str.split('_').join(' ') : '';
    return capitalize(formattedStr);
};
